







































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Copy from "@/components/copy.vue";
import Zygczb from "./zygczb.vue";
import Yanse from "./yanse.vue";
import Wenli from "./wenli.vue";
import Biaoqian from "./biaoqian.vue";
import {
  getBiduiPreviewZygczb,
  getBiduiPreviewYanse,
  getBiduiPreviewWenli,
  getBiduiPreviewBiaoqian,
  exportBiduiData
} from "@/request/idr";
@Component({
  components: {
    Copy,
    Zygczb,
    Yanse,
    Wenli,
    Biaoqian
  }
})
export default class IdrBiduiPreview extends Vue {
  @Prop()
  private tongues: any;
  private controller: any = {
    中医观察指标: true,
    影像组学参数: false,
    颜色特征: false,
    纹理特征: false,
    舌图标签: false,
    third: ""
  };
  private cPart: any = "";
  private message: any = {};
  /**
   * @description 关闭预览
   */
  private close() {
    this.$emit("close");
  }
  /**
   * @description 获得中医观察指标
   */
  private fetchZygczb() {
    const load = this.$loading({
      text: "加载中..."
    });
    return new Promise((resolve, reject) => {
      const ids: any[] = [];
      this.tongues.map((item: any) => {
        ids.push(item.tongue_id);
      });
      const params: any = {
        tongue_ids: ids
      };
      getBiduiPreviewZygczb(this, params)
        .then((data: any) => {
          this.message = data;
          this.cPart = "中医观察指标";
          this.controller["舌图标签"] = false;
          this.controller["中医观察指标"] = true;
          resolve();
        })
        .catch(() => {
          reject();
        })
        .finally(() => {
          load.close();
        });
    });
  }
  /**
   * @description 获得颜色特征
   */
  private fetchYanse(leibie, buwei, key) {
    const load = this.$loading({
      text: "加载中..."
    });
    const ids: any[] = [];
    this.tongues.map((item: any) => {
      ids.push(item.tongue_id);
    });
    const params: any = {
      tongue_ids: ids,
      类别: leibie,
      部位: buwei
    };
    getBiduiPreviewYanse(this, params)
      .then((data: any) => {
        this.message = data;
        this.controller["third"] = key;
        this.cPart = "颜色特征";
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 获得纹理特征
   */
  private fetchWenli(leibie, key) {
    const load = this.$loading({
      text: "加载中..."
    });
    const ids: any[] = [];
    this.tongues.map((item: any) => {
      ids.push(item.tongue_id);
    });
    const params: any = {
      tongue_ids: ids,
      类别: leibie
    };
    getBiduiPreviewWenli(this, params)
      .then((data: any) => {
        this.message = data;
        this.controller["third"] = key;
        this.cPart = "纹理特征";
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 获得舌图标签
   */
  private fetchBiaoqian() {
    const load = this.$loading({
      text: "加载中..."
    });
    const ids: any[] = [];
    this.tongues.map((item: any) => {
      ids.push(item.tongue_id);
    });
    const params: any = {
      tongue_ids: ids
    };
    getBiduiPreviewBiaoqian(this, params)
      .then((data: any) => {
        this.message = data;
        this.cPart = "舌图标签";
        this.controller["舌图标签"] = true;
        this.controller["中医观察指标"] = false;
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 导出
   */
  private exportData() {
    const load = this.$loading({
      text: "加载中..."
    });
    const ids: any[] = [];
    this.tongues.map((item: any) => {
      ids.push(item.tongue_id);
    });
    const params: any = {
      tongue_ids: ids
    };
    exportBiduiData(this, params)
      .then((data: any) => {
        const u =
          window.API_ROOT + "api/wajue/download?filename=" + data.file_name;
        window.open(u);
      })
      .finally(() => {
        load.close();
      });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchZygczb();
  }
}
